import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-packets',
  templateUrl: './packets.component.html',
  styleUrls: ['./packets.component.scss']
})
export class PacketsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
